import {
  PositionalTextParams,
  NamedTextParams,
  PositionalReactParams,
  NamedReactParams,
} from './types';

const hasReact = (params: object) =>
  Object.values(params).some(
    v =>
      v !== null &&
      v !== undefined &&
      typeof v !== 'string' &&
      typeof v !== 'number' &&
      typeof v !== 'boolean',
  );

export function interpolate<T extends string>(
  str: string,
  params: PositionalTextParams | NamedTextParams<T> | PositionalReactParams | NamedReactParams<T>,
) {
  if (Array.isArray(params)) {
    const positionalParams = params as PositionalTextParams;
    const hasReactParams = hasReact(positionalParams);
    const re = () => /(%s)/g;
    let i = 0;
    if (hasReactParams) {
      return str
        .split(/(%s)/g)
        .filter(w => !!w)
        .map(w => {
          const [, key] = re().exec(w) ?? [];
          if (!key) {
            return w;
          } else {
            const param = positionalParams[i++];
            if (param === undefined || param === null) {
              console.error(`Missing param ${i} in the string "${str}"`);
              return w;
            }
            return param;
          }
        });
    } else {
      return str.replace(re(), _ => String(positionalParams[i++] ?? _));
    }
  } else {
    const namedParams = params as NamedTextParams<T>;
    const hasReactParams = hasReact(namedParams);
    const re = () => /%{([^}]*)}/g;
    if (hasReactParams) {
      return str
        .split(/(%{[^}]*})/g)
        .filter(w => !!w)
        .map(w => {
          const [, key] = re().exec(w) ?? [];
          if (!key) {
            if (key === '') {
              console.error(`Empty param in the string "${str}"`);
            }
            return w;
          } else {
            const param = namedParams[key as T];
            if (param === undefined || param === null) {
              console.error(`Missing param "${key}" in the string "${str}"`);
              return w;
            }
            return param;
          }
        });
    } else {
      return str.replace(re(), (_, key) => String(namedParams[key as T] ?? _));
    }
  }
}
